import React, { useState, useEffect, useContext } from 'react';
import { api } from './api/api';
import { AuthContext } from '../App';

// ADMIN: pick any fobase user to calculate the setup for, using THEIR GPRO
// token instead of the caller's own. Non-ADMIN: same, but limited to users
// currently covered via an approved Holiday Mode request (see Settings).
const UserImpersonationPicker = ({ value, onChange }) => {
  const { userRole } = useContext(AuthContext);
  const isAdmin = userRole === 'ADMIN';
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const request = isAdmin ? api.get('/management/users') : api.get('/holidays/active-coverage');
    request
      .then(res => {
        if (cancelled) return;
        let list = res.data || [];
        if (isAdmin) list = list.filter(u => u.gprotoken);
        list = [...list].sort((a, b) => `${a.firstname} ${a.lastname}`.localeCompare(`${b.firstname} ${b.lastname}`));
        setUsers(list);
      })
      .catch(() => { if (!cancelled) setUsers([]); })
      .finally(() => { if (!cancelled) { setLoading(false); setLoaded(true); } });
    return () => { cancelled = true; };
  }, [isAdmin]);

  if (!isAdmin && (!loaded || users.length === 0)) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <label className="fb-label" style={{ marginBottom: 0, fontSize: 12 }}>Calculate for</label>
      <select
        className="fb-select"
        style={{ fontSize: 12, padding: '5px 24px 5px 8px', width: 'auto' }}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
      >
        <option value="">{loading ? 'Loading users…' : 'Myself'}</option>
        {users.map(u => (
          <option key={u.id} value={u.id}>{u.firstname} {u.lastname}</option>
        ))}
      </select>
    </div>
  );
};

export default UserImpersonationPicker;
